import { render } from "./TabelleQuellen.vue?vue&type=template&id=53e6dbc9&scoped=true"
import script from "./TabelleQuellen.vue?vue&type=script&lang=js"
export * from "./TabelleQuellen.vue?vue&type=script&lang=js"

import "./TabelleQuellen.vue?vue&type=style&index=0&id=53e6dbc9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53e6dbc9"

export default script